import {getExamRoomUser} from '@/api/examRoom';

export default {
  namespaced: true,
  state: {
    streamInfo: {},
    user: {},
    deviceConnect: {
      webcam: false,
    },
    examStatus: null,
    frontConnect: false,
    sideConnect: false,
    screenConnect: false,

    mediaStart: false,
    webRTCStart: false,
    cheatStart: false,
    detectStart: false,
    chatStart: false,
    chatArrived: false,
  },
  getters: {
    getUser(status) {
      return status.user;
    },
    getStreamInfo(state) {
      return state.streamInfo;
    },
    getDeviceConnect(state) {
      return state.deviceConnect;
    },
    getFrontConnect(state) {
      return state.frontConnect;
    },
    getSideConnect(state) {
      return state.sideConnect;
    },
    getScreenConnect(state) {
      return state.screenConnect;
    },
    getMediaStart(state) {
      return state.mediaStart;
    },
    getWebRTCStart(state) {
      return state.webRTCStart;
    },
    getCheatStart(state) {
      return state.cheatStart;
    },
    getDetectStart(state) {
      return state.detectStart;
    },
    getExamStatus(state) {
      return state.examStatus;
    },
    getChatStart(state) {
      return state.chatStart;
    },
    getChatArrived(state) {
      return state.chatArrived;
    },
  },
  mutations: {
    setUser(status, payload) {
      status.user = payload;
    },
    setDeviceConnect(status, payload) {
      status.deviceConnect = {...status.deviceConnect, ...payload};
    },
    setFrontConnect(status, state) {
      status.frontConnect = state;
      status.deviceConnect = {...status.deviceConnect, webcam: state};
    },
    setSideConnect(status, state) {
      status.sideConnect = state;
      status.deviceConnect = {...status.deviceConnect, mobile: state};
    },
    setScreenConnect(status, state) {
      status.screenConnect = state;
      status.deviceConnect = {...status.deviceConnect, screen: state};
    },
    setMediaStart(status, state) {
      status.mediaStart = state;
    },
    setWebRTCStart(status, state) {
      status.webRTCStart = state;
    },
    setCheatStart(status, state) {
      status.cheatStart = state;
    },
    setDetectStart(status, state) {
      status.detectStart = state;
    },
    setExamStatus(status, state) {
      status.examStatus = state;
    },
    setChatStart(status, state) {
      status.chatStart = state;
    },
    setChatArrived(status, state) {
      status.chatArrived = state;
    },
  },
  actions: {
    getExamRoomUser(context, userId) {
      return getExamRoomUser(userId).then(response => {
        const resTime = response.headers['date'];
        const userInfo = {resTime, ...response.data};
        context.commit('setUser', userInfo);
        return userInfo;
      });
    },
  },
};
